import React from 'react';
import styles from './About.module.css';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
          aria-label="返回上一页"
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h2 className={styles.headerTitle}>关于我们</h2>
      </header>

      <main className={styles.content}>
        {/* ── 愿景 Hero ── */}
        <section className={styles.heroSection}>
          <div className={styles.heroIconBox}>
            <span className="material-symbols-outlined">lightbulb</span>
          </div>
          <h1 className={styles.heroTitle}>我们的愿景</h1>
          <div className={styles.heroQuotes}>
            <p className={styles.heroQuoteItalic}>阅读，是思想的解放。</p>
            <p className={styles.heroQuoteItalic}>学习，是命运的重塑。</p>
          </div>
          <p className={styles.heroSubtext}>
            让中华文化赋予你深厚的力量，<br />
            让英文带你看见更大的世界。
          </p>
          <p className={styles.heroHighlight}>
            愿我们打造的，不只是一个软件，<br />
            而是一段通往自由与丰盛的成长旅程。
          </p>
        </section>

        {/* ── 致谢 ── */}
        <section className={styles.thanksCard}>
          <div className={styles.thanksDecoIcon}>
            <span className="material-symbols-outlined">favorite</span>
          </div>
          <div className={styles.thanksHeader}>
            <span className={`material-symbols-outlined ${styles.thanksHeaderIcon}`}>volunteer_activism</span>
            <h2 className={styles.cardTitle}>致谢</h2>
          </div>
          <div className={styles.thanksBody}>
            <p>
              首先，感谢写下这些书的作者们。很冒昧地在没有作者许可的情况下，将他们的作品用 AI 翻译为英文。初心是希望大家在学习英语时，能有多个维度的输入和知识链接——比如联想到看过的电视剧画面、小说情节等，让学习不再枯燥。
            </p>
            <p className={styles.thanksQuote}>
              如果侵犯了作者的著作权，深表歉意，请联系我们删除相关书籍。如果侵犯了相关平台的利益，请官方平台出示对应著作的授权证明，我们会立马下架。
            </p>
            <p>
              最后，感谢自己的热爱，以及各种 AI 工具和平台的支持，才得以在业余时间完成这个软件。
            </p>
          </div>
        </section>

        {/* ── 致想复制我们的人 ── */}
        <section className={styles.copyCard}>
          <div className={styles.copyHeader}>
            <span className={`material-symbols-outlined ${styles.copyHeaderIcon}`}>content_copy</span>
            <h2 className={styles.cardTitle}>致想复制我们的人</h2>
          </div>
          <div className={styles.copyGrid}>
            <div className={styles.copyQuotes}>
              <p>被模仿，是影响力的证明。</p>
              <p>但复制，只能追赶；</p>
              <p className={styles.copyQuoteHighlight}>创造，才能领先。</p>
            </div>
            <div className={styles.copySide}>
              <p>
                如果你有能力做出相似的产品，<br />
                更希望你有勇气做出不同的方向。
              </p>
            </div>
          </div>
          <div className={styles.copyBottom}>
            <p>
              市场不缺相同的声音，它需要新的视角、新的价值、新的表达。
            </p>
            <p>
              愿你不只是追随，而是真正参与创造。<br />
              让世界，因为你的思考与付出，而更美一分。
            </p>
          </div>
        </section>

        {/* ── 联系我们 ── */}
        <section className={styles.contactSection}>
          <p className={styles.contactText}>
            如有任何问题、建议或合作需求，欢迎通过以下邮箱联系：
          </p>
          <a className={styles.contactLink} href="mailto:xxx@gmail.com">
            xxx@gmail.com
          </a>
        </section>

        {/* ── 页脚 ── */}
        <footer className={styles.footer}>
          <p>© 2025 EnNovels · 致力为每位学习者提供优质的英文阅读体验。</p>
        </footer>
      </main>
    </div>
  );
};

export default About;
